/** @jsx jsx */

import { jsx, render, Field, Variable, Mutation, SelectionSet, IdScalar, IntScalar } from "graphql-jsx";
import { clients } from "utils/clients";
import { UuidScalar } from "GraphQL/Scalars";

type Option = Readonly<{
  uuid: string;
  metadataId: string;
  order: number;
}>;

export const UpdateGoodsMetadata = async (option: Option) => {
  const $id = <Variable name="id" scalar={<UuidScalar isNullable={false} />} value={option.uuid} />;
  const $metadataId = <Variable name="metadata_id" scalar={<IdScalar isNullable={false} />} value={option.metadataId} />;
  const $order = <Variable name="exposure_order" scalar={<IntScalar isNullable />} value={option.order} />;
  const { query, variables } = render(
    <Mutation operationName="UPDATE_GOODS_METADATA_RELATION">
      <SelectionSet
        name="updateMetadata_goods_relation"
        alias="updateGoodsMetadata"
        argument={{
          where: { id: $id },
          data: {
            metadata: {
              connect: {
                metadata_id: $metadataId
              }
            },
            exposure_order: $order
          }
        }}
      >
        <Field name="id" />
      </SelectionSet>
    </Mutation>
  );
  type Data = Readonly<{
    updateGoodsMetadata: Readonly<{
      id: string;
    }>[];
  }>;
  return await clients.goods.request<Data>(query, variables);
};
